package fr.manyverse.app.presentation.viewmodel

import fr.manyverse.app.domain.usecase.GetTableMemberNotesUseCase
import fr.manyverse.app.domain.usecase.SaveTableMemberNotesUseCase
import fr.manyverse.app.presentation.state.ActionUiState
import fr.manyverse.app.presentation.state.AsyncUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class PlayerNotesViewModel(
    private val tableId: String,
    private val userId: String,
    private val getTableMemberNotesUseCase: GetTableMemberNotesUseCase,
    private val saveTableMemberNotesUseCase: SaveTableMemberNotesUseCase
) : BaseViewModel() {

    private val _notesState = MutableStateFlow<AsyncUiState<String>>(AsyncUiState.Loading)
    val notesState: StateFlow<AsyncUiState<String>> = _notesState.asStateFlow()

    private val _saveState = MutableStateFlow<ActionUiState>(AsyncUiState.Idle)
    val saveState: StateFlow<ActionUiState> = _saveState.asStateFlow()

    /**
     * Relues à chaque ouverture : la liste des membres ne les contient pas, et leur modification
     * n'est pas diffusée par Realtime (le MJ verrait sinon une version périmée).
     */
    fun loadNotes() {
        launchAsync(_notesState) { getTableMemberNotesUseCase(tableId, userId) }
    }

    fun saveNotes(notes: String) {
        launchAction(_saveState) {
            saveTableMemberNotesUseCase(tableId, userId, notes)
        }
    }

    fun resetSaveState() = resetState(_saveState)
}
